module.exports = __webpack_public_path__ + "img/phonepe_long.494a33c0.svg";